<app-navbar></app-navbar>

<div *ngIf="loading">
  <div class="container">
    <div class="row my-3">
      <div class="col-lg-12">
          <div class=" py-10 bg-white">
            <div class="row">
              <div class="col-lg-12">
                  <div class="ms-4 me-2" style="height: 70px;">
                      <div class="skeleton-card" *ngIf="loading">

                      </div>
                  </div>
                  <div class="ms-4 my-2 me-2 " style="height: 30px;" *ngIf="loading">
                      <div class="skeleton-card" ></div>
                  </div>
                  <div class="ms-5 mt-4" style="height: 50px;">
                      <div class="skeleton-card" style="width: 200px;">

                      </div>
                  </div>
              </div>

            </div>
          </div>
      </div>
    </div>
    <app-header-spinner></app-header-spinner>

  </div>
  </div>
<section class="py-7 py-lg-8 pb-lg-22 " *ngIf="!loading">
  <div class="welcome-area welcome-area--l1 bg-white " *ngIf="!isLegalPage()">
    <div class="container ">
      <div class="row">
        <div class="col-xl-6 col-lg-7 col-md-8">
          <div class="mb-4 mt-10">
            <h3 class="display-4 fw-bold mb-3 text-shadow">
              {{posts.title}}
            </h3>
           
            <p class="lead mb-2" >
              {{ posts.metaDescription }}
            </p>

            <a routerLink="/login" class="btn btn-primary btn-lg shadow--orange rounded-4 ">Get Started with TouchConnet</a>
          </div>
        </div>
        <div class="col-xl-6 col-lg-5 col-md-10 d-none d-md-block d-lg-block">
          <p-image src="{{posts.image}}" [preview]="true" alt="Image" width="250">
            <ng-template #indicator>
                <i class="pi pi-search"></i>
            </ng-template>
            <ng-template #image>
                <img src="{{posts.image}}" alt="image" width="250" />
            </ng-template>
            <ng-template #preview let-style="style" let-previewCallback="previewCallback">
                <img src="{{posts.image}}" alt="image" [style]="style" (click)="previewCallback()" />
            </ng-template>
        </p-image>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid " *ngIf="!loading">

    <div class="row justify-content-center">
      <div class="col-xl-8 col-lg-8 col-md-12 col-12 mb-2">
        <div class="text-center mb-4">

          <h1 class="display-3 fw-bold mb-4">{{posts.title}}</h1>

        </div>

      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-8 col-lg-8 col-md-12 col-12 mb-2">
        <!-- Descriptions -->
        <div class="my-3">
          <div  [innerHTML]="posts.description" id="richText"></div>
        </div>


      </div>
    </div>
  </div>

</section>
